<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>加油订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
              size="mini"
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="100px"
              autocomplete="on"
      >
        <!---->
        <el-row :gutter="24">
          <el-col :span="21">
            <el-form-item label="关键字">
              <el-input @input="goSearch" v-model="searchForm.keyword" placeholder="请输入关键字"  clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="开票">
              <el-select width="500" clearable  v-model="searchForm.is_invoice"  placeholder="请选择开票状态">
                <el-option key="" label="全部" value="">
                </el-option>
                <el-option key="1" label="已开" value="1">
                </el-option>
                <el-option key="0" label="未开" value="0">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付状态" >
              <el-select width="500" @change="statusChange" clearable  v-model="searchForm.pay_status"  placeholder="请选择支付状态">
                <el-option key="" label="全部" value="">
                </el-option>
                <el-option key="1" label="已支付" value="1">
                </el-option>
                <el-option key="0" label="待付" value="0">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="font-size: 14px">
            <div class="toggle-button" @click="isCollapsed =!isCollapsed">
              <span>筛选条件</span>
              <i :class="collapseIcon" class="el-icon--right"></i>
            </div>
          </el-col>
        </el-row>
        <!---->
        <el-collapse-transition>
          <div v-show="!isCollapsed" class="condition-content">
            <el-form-item label="创建时间">
              <el-date-picker
                      @change="changeTime"
                      v-model="searchForm.start_end_date"
                      type="daterange"
                      align="right"
                      size="mini"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="startEndOptions">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <!---->
      </el-form>

       <div style="margin:20px 0">
         <el-row :gutter="20">
           <el-col :span="6">
             <div>


               <el-statistic
                       group-separator=","
                       :precision="2"
                       title="待开票金额"
               >
                 <template slot="formatter">
                   <span>{{sumAmount['noInvoiceAmount']||0}}</span>
                 </template>
               </el-statistic>
             </div>
           </el-col>
           <el-col :span="6">
             <div>
               <el-statistic title="可提现金额">
                 <template slot="formatter">
                   <span>{{sumAmount['invoiceAmount']||0}}</span>
                 </template>
               </el-statistic>
             </div>
           </el-col>
           <el-col :span="6">
             <div>
               <el-statistic
                       group-separator=","
                       :precision="2"
                       decimal-separator="."
                       title="订单总金额"
               > <template slot="formatter">
                 <span>{{sumAmount['payAmount']||0}}</span>
               </template>
               </el-statistic>
             </div>
           </el-col>
           <el-col :span="6">
             <div>
               <el-statistic  title="退款总额">
                 <template slot="formatter">
                  <span>0</span>
                 </template>
               </el-statistic>
             </div>
           </el-col>
         </el-row>
       </div>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        stripe
        border
        size="mini"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="交易日期"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time|timeFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="交易金额(元)"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.order_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="油站名称"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.oilshop?scope.row.oilshop.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="运企名称"
                width="120"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lgsshop?scope.row.lgsshop.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="司机编号"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.owner?scope.row.owner.sn:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="司机姓名"
                width="120"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.owner?scope.row.owner.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="车牌号"
                width="100"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.carinfo?scope.row.carinfo.car_number:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="开票状态"
          :show-overflow-tooltip='true'
          width="100"
        >
          <template slot-scope="scope">
            <div style="display: flex;flex-direction: column;">
            <span style="color: #5daf34" v-if="scope.row.is_invoice==1">已开</span>
              <span  v-if="scope.row.is_invoice==0"></span>
              <span style="color: #5daf34" v-if="scope.row.is_invoice==1">{{ scope.row.time_invoice?timeFormat(scope.row.time_invoice):''}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="支付状态"
          :show-overflow-tooltip='true'
          width="100"
        >
          <template slot-scope="scope">
            <div style="display: flex;flex-direction: column">
              <span style="color: #5daf34" v-if="scope.row.pay_status==2">已支付</span>
              <span  v-if="scope.row.pay_status!=2"></span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.pay_status==2&&scope.row.file_url==null" @click="goInvoice(scope.row)" type="text" style="color:#666666; margin-left: 16px;">
              上传发票
            </el-button>

            <el-link
                    v-if="scope.row.pay_status==2&&scope.row.file_url"
                    type="primary"
                    :underline="false"
                    :href="scope.row.file_url"
                    :download="scope.row.id+'.pdf'"
            >
              <el-button style="color:#5AB973;margin-left: 16px;" type="text" icon="el-icon-download">发票</el-button>
            </el-link>


            <el-button size="mini" icon="el-icon-download" v-if="scope.row.pay_status==2"  @click="downPay(scope.row)" type="text" style="margin-left: 16px;">
              凭证
            </el-button>
            <el-button size="mini" @click="showGoods(scope.row)" type="text" style="margin-left: 16px;color: #666">
              详情
            </el-button>

          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

   <!--加油详情-->
    <el-drawer
      title="订单详情"
      :visible.sync="drawer"
      v-if="om"
      size="60%"
      :with-header="false">
      <div style="margin: 30px 12px;">
      <el-descriptions title="基本信息" direction="horizontal" :column="3" border>
        <template slot="extra">
          <el-button type="sunccess" size="mini">下载凭证</el-button>
          <el-button type="sunccess" size="mini">提现</el-button>
        </template>
        <el-descriptions-item label="订单编号">{{om.sn}}</el-descriptions-item>
        <el-descriptions-item label="总金额">{{formatNumber(om.order_amount)}}</el-descriptions-item>
        <el-descriptions-item label="下单日期">{{om.add_time|timeFormat}}</el-descriptions-item>
        <el-descriptions-item label="油站名称">{{om.oilshop.name||''}}</el-descriptions-item>
        <el-descriptions-item label="运企名称">{{om.lgsshop.name||''}}</el-descriptions-item>
        <el-descriptions-item label="司机">{{om.owner.name||''}}/{{om.carinfo.car_number||''}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="发票详情" direction="horizontal" :column="3" border>
        <el-descriptions-item label="名称">{{om.invoice.name}}</el-descriptions-item>
        <el-descriptions-item label="税号">{{om.invoice.tax_id}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{om.invoice.mobile}}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{om.invoice.email||''}}</el-descriptions-item>
        <el-descriptions-item label="附件"> <el-image
                style="width: 100px; height: 100px"
                :src="om.file_url||''"
                fit="fill"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="开票日期">{{om.time_invoice|timeFormat}}</el-descriptions-item>
      </el-descriptions>
      <el-table
        style="margin-top: 20px;"
        ref="multipleTable"
        :data="goods_list"
        size="mini"
        stripe
        border
      >
        <el-table-column  type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="产品名称"
          width="150"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.product_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="单位"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.unit}}</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </el-drawer>
    <!--开发票-->

    <eInvoiceForm :formData="formData1"
              :visible.sync="visible1"
              :title="title1"
              :closeForm="closeForm1"
              v-on:eventChoose="eChooseRs1"
    />
  </div>
</template>

<script>
  import moment from 'moment'     //日期时间转换
  import eInvoiceForm from "../common/eInvoiceForm.vue";
  export default {
    name: "oilOrderList",
    components: {
      eInvoiceForm
    },
    props: {},
    data() {
      return {
        sumAmount:[],



        om:null,
        formData1:{item:null},
        visible1:false,
        title1:'',

        invoiceVisible:false,
        isCollapsed:true,
        drawer:false,
        goods_list:[],
        startEndOptions:{
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        // 搜索
        searchForm: {
          is_invoice:'',
          name: "",
          keyword:'',
          start_end_date:'',
          status:'',
          pay_status:''
        },
        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    computed: {
      collapseIcon() {
        return this.isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      }
    },
    created() {
      this.getOilOrderSumAmount();
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {
      formatNumber(num) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(num);
      },
      goDownInvoice(){

      },
      downPay(item){
        //下载凭证
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          order_id: item.id
        }
        this.$axios.yeeDown(param).then(res=>{
          if(res.code == 200){

            // Base64 编码的 PDF 数据
            const base64Data = res.data.data;

            // 将 Base64 转换为 Blob
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // 创建下载链接
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'document.pdf';
            document.body.appendChild(link);
            link.click();

            // 清理
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log(res)
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      goInvoice(row){
        this.title1="上传发票";
        this.formData1.item=row;
        this.visible1=true;
      },
      closeForm1(){
        this.visible1=false;
      },
      eChooseRs1(id,...params){
        console.log(id,params)

        // console.log('eChooseDoc',params)
        // if(this.type_img==1){
        //   this.ruleForm.file_url=params[1];
        // }

      },
      statusChange(){
        this.goSearch();
      },
      changeTime(){
       this.goSearch();
      },
      goSearch(){
        this.currentPage=1;
        this.tableLoadData=[];
        this.total=0;
        this.DataList();
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      showGoods(row){
        this.om=row;
        this.drawer = true;
        this.goods_list=row.goods;
      },
      getAge(birth){
        if(birth){
          let birthday = birth;
          let now = new Date().getTime();
          let hours = (now-birthday*1000)/3600000;
          let year = Math.floor(hours / (24 * 30 * 12));
          return year
        }else{
          return null
        }
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.findOilShopOrderListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getOilOrderSumAmount(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:sessionStorage.getItem('shop_id'),
        }
        this.$axios.findOilOrderSumAmount(param).then(res=>{
          if(res.code == 200){
            this.sumAmount = res.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 新增
      addData() {
        this.$router.push('/hisOrderForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        this.tableLoadData=[];
        this.pageNum=1;
        this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
